const getMultiValueProperty = require('../getMultiValueProperty');
const getOuterBBox = require('../getOuterBBox');
const getRootPosition = require('../getRootPosition');

/**
 * A small wrapper for
 * @see getOuterBBox
 * to get style and angle from the root and then return bbox of it.
 * @param {Root} root
 * @returns {{
 *     top: Number,
 *     left: Number,
 *     width: Number,
 *     height: Number,
 *     bottom: Number,
 *     right: Number
 * }}
 */
const getRootOuterBBox = (root = {}) => {
    let angle = 0;
    const { transform } = root.style;

    if (transform) {
        const rotateValue = getMultiValueProperty(transform, 'rotate');

        if (rotateValue) {
            angle = rotateValue.replace('deg', '') || 0;
        }
    }

    return getOuterBBox(getRootPosition(root), angle);
};

module.exports = getRootOuterBBox;
